export default `float i,g,e,s;
    vec3 q=p; s=5.;
    for(int j=0;j++<6;s*=e)
      p=sign(p)*(1.7-abs(p-1.7)),
      p=p*(e=8./clamp(dot(p,p),.3,5.))+q-vec3(.8,12.0,.8);
    return length(p.yz)/s;
  }`